<template>
    <div class="content-box">
        <div class="compose-header">
            <el-input class="compose-input" v-model="queryForm.title" placeholder="请输入标题" clearable></el-input>
            <el-select v-model="queryForm.groupId" class="compose-input" placeholder="请选择分组类型" clearable>
                <el-option v-for="item in groupTypeList" :key="item.groupId" :label="item.groupName" :value="item.groupId">
                </el-option>
            </el-select>
            <el-select class="compose-input" v-model="queryForm.publicType" placeholder="请选择公共属性" clearable>
                <el-option label="启用" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
            </el-select>

            <el-select class="compose-input" v-model="queryForm.appType" placeholder="请选择app"  clearable>
                <el-option label="中医大脑" :value="0"></el-option>
                <el-option label="望舌知康" :value="1"></el-option>
            </el-select>

            <el-select class="compose-input" v-model="queryForm.shortcutEntry" placeholder="请选择快捷入口" clearable>
                <el-option label="启用" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
            </el-select>
            <el-select class="compose-input" v-model="queryForm.status" placeholder="请选择状态" clearable>
                <el-option label="启用" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
            </el-select>
            <el-button type="primary" class="compose-btn" @click="handleSearch">搜索</el-button>
            <el-button type="plain" class="compose-btn" icon="el-icon-plus"
                @click="handleEdit">新增app排版</el-button>
            <!-- <span class="merchant--name">{{ brandName || "" }}</span> -->
        </div>
        <div class="table-list">
            <el-table :data="tableData" style="width: 100%" max-height="600" :header-cell-style="headerCellStyle" border
                v-loading="loading" :cell-style="cellStyle">

                <el-table-column prop="id" label="主键" width="60">
                </el-table-column>

                <el-table-column prop="title" label="标题" width="80">
                </el-table-column>

                <el-table-column prop="subTitle" label="子标题" width="80">
                </el-table-column>
                <el-table-column prop="groupName" label="分组类型" width="110">
                    <template slot-scope="scope">
                        <div class="device-online">{{ getGroupName(scope.row.groupId) }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="icon" label="显示logo" width="100">
                    <template slot-scope="scope">
                        <img v-if="scope.row.icon" :src="scope.row.icon" class="icon-avatar" />
                    </template>
                </el-table-column>
                <el-table-column prop="appType" label="APP" width="80">
                    <template #default="{ row }">
                        {{row.appType ? "望舌知康" : "中医大脑"}}
                    </template>
                </el-table-column>
                <el-table-column prop="jumpPath" label="跳转的路径">
                </el-table-column>
                <el-table-column v-if="merchantId" prop="useLog.hideStatus" label="启用状态" width="120">
                    <template #default="{ row }">
                        {{
                            row.publicType ? (row.useLog?.hideStatus ? "否" : "是") : "是"
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="publicType" label="公共属性" width="120">
                    <template #default="{ row }">
                        {{ row.publicType ? "是" : "否" }}
                    </template>
                </el-table-column>
                <el-table-column prop="shortcutEntry" label="快捷入口" width="120">
                    <template #default="{ row }">
                        {{ row.shortcutEntry ? "是" : "否" }}
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序" width="60">
                    <template #default="{ row }">
                        {{ row.publicType && merchantId ? row.useLog?.sort : row.sort }}
                    </template>
                </el-table-column>
                <el-table-column prop="modifiedBy" label="操作人" width="100">
                    <!-- <template #default="{row}">{{}}</template> -->
                </el-table-column>
                <el-table-column prop="updateTime" label="最后操作时间" width="160">
                    <!-- <template #default="{row}"></template> -->
                </el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button style="margin-right: 10px;" type="text" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button v-if="merchantId && scope.row.publicType && scope.row.pageType" style="margin-right: 10px;" type="text" @click="handlePageCustom(scope.row)">页面定制</el-button>
                        <el-switch @change="($event) => handleStatusChange(scope.row, $event)" v-model="scope.row.status" active-color="#13ce66" v-if="!merchantId"
                            inactive-color="#DCDFE6" :active-value="1" :inactive-value="0">
                        </el-switch>
                        <el-button v-if="!scope.row.publicType && merchantId" type="text" @click="handleDelete(scope.row)"
                            class="danger-color">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>

            <!-- 分页 -->
            <el-pagination style="margin-top: 20px" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes"
                :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="itemTotal"></el-pagination>

            <el-dialog title="新增/编辑 app排版" :visible.sync="dialogVisible" width="460px" :before-close="dialogClose">
                <div class="edit-box">
                    <el-form label-position="left" label-width="100px" :model="formData" ref="validateForm"
                        :rules="rules">
                        <el-form-item label="App" prop="appType">
                            <el-select :disabled="merchantAppComposeDisabledFlag" v-model="formData.appType" placeholder="请选择app" class="dialogInput">
                                <el-option label="中医大脑" :value="0"></el-option>
                                <el-option label="望舌知康" :value="1"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="app标题:" prop="title">
                            <el-input :disabled="merchantAppComposeDisabledFlag" v-model="formData.title"
                                class="dialogInput" placeholder="app标题" maxlength="35">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="app子标题:" prop="subTitle">
                            <el-input :disabled="merchantAppComposeDisabledFlag" v-model="formData.subTitle"
                                class="dialogInput" placeholder="app子标题" maxlength="35">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="logo上传:" prop="img">
                            <div class="avatar-uploader avatar-uploader-box">
                                <el-upload :action="$uploadImg + 'icon'" :show-file-list="false"
                                    :before-upload="beforeAvatarUpload" :on-success="onSuccess"
                                    :disabled="merchantAppComposeDisabledFlag">
                                    <img v-if="formData.icon" :src="formData.icon" class="icon-avatar" />
                                    <i v-else class="el-icon-plus avatar-uploader-icon avatar-uploader-icon-form"></i>
                                </el-upload>
                            </div>
                            <p class="avatar-desc">仅支持JPG、PNG两种格式，图片大小不得超过500kb</p>
                        </el-form-item>

                        <el-form-item label="logo路径:" prop="icon">
                            <el-input :disabled="merchantAppComposeDisabledFlag" v-model="formData.icon"
                                class="dialogInput" placeholder="logo路径" maxlength="135">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="跳转的地址:" prop="jumpPath">
                            <el-input :disabled="merchantAppComposeDisabledFlag" v-model="formData.jumpPath"
                                class="dialogInput" placeholder="跳转的地址">
                            </el-input>
                        </el-form-item>
                        <el-form-item v-if="merchantAppComposeDisabledFlag" label="排版顺序:" prop="useLog.sort">
                            <el-input v-model="formData.useLog.sort" class="dialogInput" maxlength="35"
                                placeholder="数字最小的在最前">
                            </el-input>
                        </el-form-item>
                        <el-form-item v-else label="排版顺序:" prop="sort">
                            <el-input v-model="formData.sort" class="dialogInput" maxlength="35" placeholder="数字最小的在最前">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="分组类型:" prop="groupId">
                            <el-select :disabled="merchantAppComposeDisabledFlag" clearable v-model="formData.groupId"
                                class="dialogInput" placeholder="分组类型">
                                <el-option v-for="item in groupTypeList" :key="item.groupId" :label="item.groupName"
                                    :value="item.groupId">
                                </el-option>
                            </el-select>
                            <p class="tip">APP是望舌知康时，请选择“其他功能”</p>
                        </el-form-item>
                        <el-form-item label="公共属性:" prop="publicType" v-if="!merchantId">
                            <el-switch :disabled="merchantId" v-model="formData.publicType" active-color="#13ce66"
                                inactive-color="#DCDFE6">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="快捷入口:" prop="shortcutEntry" v-if="!merchantId">
                            <el-switch :disabled="merchantId" v-model="formData.shortcutEntry" active-color="#13ce66"
                                inactive-color="#DCDFE6">
                            </el-switch>
                            <p class="tip">打开则在【智能辩证】页面的菜单显示</p>
                        </el-form-item>
                        <el-form-item label="个性配置:" prop="personalityConfig" v-if="!merchantId">
                            <el-switch :disabled="merchantId" v-model="formData.personalityConfig"
                                active-color="#13ce66" inactive-color="#DCDFE6">
                            </el-switch>
                            <p class="tip">打开只影响已关联门店进行展示</p>
                        </el-form-item>
                        <el-form-item label="个性门店:" prop="personalityStore" v-if="!merchantId && formData.personalityConfig">
                            <el-input v-model="formData.personalityStore" class="dialogInput"
                                placeholder="只能输入门店ID，多个门店ID使用-分开" @input="onPersonalityStoreInput">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="启用:" prop="useLog.preHideStatus" v-if="merchantAppComposeDisabledFlag">
                            <el-switch v-model="formData.useLog.preHideStatus" active-color="#13ce66"
                                inactive-color="#DCDFE6">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="状态:" prop="status" v-if="!merchantId">
                            <el-switch v-model="formData.status" active-color="#13ce66"
                                inactive-color="#DCDFE6" :active-value="1" :inactive-value="0">
                            </el-switch>
                            <p class="tip">禁用后，该菜单通用门店和品牌方门店都下线掉</p>
                        </el-form-item>
                        <el-form-item label="页面类型:" prop="pageType" v-if="!merchantId && formData.publicType">
                            <el-select v-model="formData.pageType" style="width: 280px;" placeholder="请选择">
                                <el-option label="智能脉诊" :value="10003"></el-option>
                                <el-option label="智能舌诊" :value="10001"></el-option>
                                <el-option label="儿童舌诊" :value="11001"></el-option>
                                <el-option label="体质辨识" :value="10004"></el-option>
                                <el-option label="AI智能辨证" :value="10007"></el-option>
                                <el-option label="智能体脂" :value="10008"></el-option>
                                <el-option label="肺功能评估" :value="10005"></el-option>
                                <el-option label="AI智能评估" :value="10006"></el-option>
                                <el-option label="AI辨证-膳食调养" :value="10011"></el-option>
                                <el-option label="AI辨证-体重管理" :value="10010"></el-option>
                            </el-select>
                            <p class="tip">选择后该入口品牌方可进行首页个性配置</p>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogClose">取消</el-button>
                        <el-button type="primary" @click="dialogConfirm">提交</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>

        <!-- 页面定制弹窗 -->
        <PageCustomDialog :visible.sync="pageCustomVisible" :row-data="pageCustomRow" @success="getData" />
    </div>
</template>

<script>
import { Mixins, Component, Watch, InjectReactive } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";

import {
    list,
    saveAppCompose,
    appComposeDelete,
    appComposeGroupList,
    updateAppComposeStatus
} from "@/api/appCompose";

import PageCustomDialog from "./pageCustomDialog.vue";

// 工具
import deepCopy from "@/utils/deepCopy";

const initFormData = {
    appType: 0,
    title: "",
    subtitle: "",
    icon: "",
    pageType: "",
};

@Component({
    components: {
        PageCustomDialog
    }
})
export default class appList extends Mixins(loading, tablePagination) {
    @InjectReactive() currentTab;

    merchantId = "";
    brandName = "";

    storeName = "";
    ownerName = "";
    phone = "";
    tableData = [];
    itemTotal = 0;
    dialogVisible = false;
    formData = {
        appType: 0,
        title: "",
        subtitle: "",
        icon: "",
        groupId: "",
        publicType: true,
        shortcutEntry: false,
        personalityConfig: false,
        personalityStore: "",
        pageType: "",
        hideStatus: false,
        status: 1,
        useLog: {
            composeId: "",
            hideStatus: false,
            preHideStatus: true,
            merchantId: this.merchantId,
            sort: 0,
        },
    };
    queryForm = {
        title: "",
        groupId: "",
        publicType: "",
        shortcutEntry: "",
        status: ""
    }

    appList = [];
    rules = {
        title: [
            { required: true, message: '请填写app标题', trigger: 'blur' }
        ],
        appType: [
            { required: true, message: '请选择app', trigger: 'blur' }
        ],
        subTitle: [
            { required: true, message: '请填写子标题', trigger: 'blur' }
        ],
        groupId: [
            { required: true, message: '请选择分组类型', trigger: 'change' }
        ],
        personalityStore: [
            { required: true, message: '请填写个性门店', trigger: 'blur' }
        ]
    };
    // groupTypeList = [{ groupType: 1, groupTypeName: "智能体测系统" }, { groupType: 2, groupTypeName: "智能调理系统" }, { groupType: 3, groupTypeName: "其他" }];
    mounted() {
        // this.getGroupTypeList();
    }

    get merchantAppComposeFlag() {
        return this.merchantId;
    }

    get merchantAppComposeDisabledFlag() {
        return Boolean(this.merchantAppComposeFlag && this.formData.publicType && this.formData.id);
    }

    getData() {
        this.showLoading();
        list({
            // title: this.title,
            // subTitle: this.subTitle,
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            merchantId: this.merchantId || 0,
            ...this.queryForm
        }).then(res => {
            this.hideLoading();
            this.tableData = res.data.list;
            this.itemTotal = res.data.total;
            this.tableData.forEach((el) => {
                el.useLog = el.useLog || {};
                el.useLog.preHideStatus = !el.useLog?.hideStatus;
                el.shortcutEntry = Boolean(el.shortcutEntry);
                el.personalityConfig = Boolean(el.personalityConfig);
            })
        }).finally(() => {
            this.hideLoading();
        });
    }
    // 上传成功
    onSuccess(res, file) {
        this.formData.icon = this.$uploadImgUrl + "/" + res.data.url;
        this.formData = deepCopy(this.formData);
    }
    // 图片上传之前限制
    beforeAvatarUpload(file) {
        const isLt1M = file.size / 1024 / 1024 < 0.5;
        if (!isLt1M) {
            this.$message.error("上传头像图片大小不能超过 500k!");
        }

        return isLt1M;
    }

    //重置分页参数
    resetPages() {
        this.currentPage = 1;
    }


    groupTypeList = [];
    getGroupTypeList() {
        this.groupTypeList = [];
        const params = {
            merchantId: this.merchantId
        }
        appComposeGroupList(params).then(res => {
            res.data.forEach((el) => {
                this.groupTypeList.unshift({
                    groupId: el.id,
                    groupName: el.name,
                    sortNum: el.sortNum
                });
            });
            this.groupTypeList.sort((a, b) => a.sortNum - b.sortNum);
        })
    }

    getGroupName(groupId) {
        return this.groupTypeList.find(el => el.groupId == groupId)?.groupName || "-";
        // switch (groupId) {
        //     case 1:
        //         return "智能体测系统";
        //     case 2:
        //         return "智能调理系统";
        //     case 3:
        //         return "其他功能";
        //     default:
        //         return "-";
        // }
    }

    // 头部输入
    changeValue(val, type) {
        this[type] = val;
    }

    // 搜索
    handleSearch() {
        this.resetPages();
        this.getData();
    }
    handleStatusChange(row, $event) {
        updateAppComposeStatus({ id: row.id, status: $event }).finally(() => {
            this.getData();
        });
    }
    handleEdit(row) {
        let { id, appType = 0, title, subTitle, sort, icon, groupId, jumpPath, publicType = true, shortcutEntry = false, personalityConfig = false, personalityStore, pageType = "", useLog = {}, status } = row;
        if (!useLog) useLog = {};
        this.formData = deepCopy({
            id,
            appType,
            title,
            subTitle,
            sort,
            icon,
            jumpPath,
            groupId,
            publicType,
            shortcutEntry,
            personalityConfig,
            personalityStore,
            pageType: pageType ?? "",
            useLog,
            shortcutEntry,
            status: status ?? 1
        });
        this.dialogVisible = true;
    }
    pageCustomVisible = false;
    pageCustomRow = {};

    handlePageCustom(row) {
        // 页面定制
        this.pageCustomRow = {
            ...row,
            merchantId: this.merchantId
        };
        this.pageCustomVisible = true;
    }
    handleDelete(row) {
        this.$confirm(`确定删除?`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
            appComposeDelete({
                id: row.id,
            }).then((res) => {
                this.getData();
                this.$message.success("删除成功");
            });
        });
    }


    dialogClose() {
        this.formData = deepCopy(initFormData);
        this.$refs['validateForm'].resetFields();
        this.dialogVisible = false;
    }
    dialogConfirm() {
        this.$refs['validateForm'].validate((valid) => {
            if (valid) {
                this.showLoading();
                const { useLog, ..._params } = this.formData;
                const params = {
                    ..._params,
                    publicType: this.merchantId ? undefined : _params.publicType,
                    shortcutEntry: this.merchantId ? undefined : Number(_params.shortcutEntry),
                    personalityConfig: this.merchantId ? undefined : Number(_params.personalityConfig),
                    pageType: this.merchantId ? undefined : _params.pageType,
                    useLog: _params.publicType && _params.id && this.merchantId ? {
                        id: useLog.id,
                        composeId: _params.id,
                        hideStatus: Number(!useLog.preHideStatus),
                        merchantId: this.merchantId,
                        sort: useLog.sort,
                    } : undefined,
                    merchantId: _params.id ? undefined : this.merchantId
                }
                console.log("保存参数", params);
                saveAppCompose(params).then(res => {
                    this.dialogClose();
                    this.resetPages();
                    this.getData();
                }).finally(() => {
                    this.hideLoading();
                });
            } else {
                console.log('error submit!!');
                return false;
            }
        })
    }

    onPersonalityStoreInput(val) {
        // 只允许输入数字和-
        this.formData.personalityStore = val.replace(/[^0-9-]/g, '');
    }

    @Watch("$route", { immediate: true })
    routeChange() {
        const path = this.$route.path;
        if (["/appCompose", "/merchantAppCompose"].includes(path)) {
            this.brandName = this.$route.query.brandName;
            this.merchantId = this.$route.query.merchantId;
        }
        this.currentTabChange();
    }

    @Watch("currentTab")
    currentTabChange() {
        if (this.currentTab != 1) return;
        this.getData();
        this.getGroupTypeList();
    }

}
</script>
<style lang="scss" scoped src="./style.scss"></style>
<style lang="scss" scoped>
.compose-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-bottom: 8px;
    background: #ffffff;
}

.compose-input {
    width: 240px;
    height: 40px;
    background: #ffffff;
    border-radius: 2px;
    margin-right: 12px;
    margin-bottom: 12px;
}

.compose-btn {
    margin-bottom: 12px;
}

.tip {
    font-size: 12px;
    color: #80858C;
}
</style>